import { DateTime } from 'luxon'
import { parseApiDateTime } from './parseApiDateTime'
import { DEFAULT_API_DATE_FORMAT } from './apiDateTimeFormats.constants'
import { resolveDisplayLocale } from './resolveDisplayLocale'

export const formatApiDate = (
  value?: string | null,
  format = DEFAULT_API_DATE_FORMAT,
  locale = 'en'
) => {
  const displayLocale = resolveDisplayLocale(locale)
  const dateTime = parseApiDateTime(value)
  if (dateTime) return dateTime.setLocale(displayLocale).toFormat(format)

  if (value === null || value === undefined || value.length === 0) return 'N/A'

  const asDate = DateTime.fromISO(value)
  if (asDate.isValid) return asDate.setLocale(displayLocale).toFormat(format)

  return 'N/A'
}
